<mat-card class="widget-card">
    <mat-card-header>
        <mat-card-title>Overall Balance</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <app-daily-balance-line-chart [dailyBalance]="dailyBalance" [showTicks]="isMobile == false" height="100%">
        </app-daily-balance-line-chart>
    </mat-card-content>
</mat-card>